module.exports = __webpack_public_path__ + "img/nora-lighting.85ab8b4e.png";